export default __webpack_public_path__ + "static/media/icon-alert.b850d203.svg";